import { Table, TableCell, TableRow } from '@amzn/meridian';
import { isValidImageFileType } from 'features/assets/assets.util';
import { Thumbnail } from 'features/traffic/components/Table/Thumbnail';
import type { AssetSearchResult } from 'generated/graphql';
import { type FC, useCallback } from 'react';
import { stylesheet } from 'typestyle';
import { ActionButtons } from './ActionButtons';

const css = stylesheet({
  colReferenceId: {
    alignItems: 'center',
    display: 'flex',
    gap: '10px',
  },
});

type ImagePreviewTableProps = {
  asset: AssetSearchResult;
  onRemoveClick: () => void;
  onUploadClick: () => void;
};

export const ImagePreviewTable: FC<ImagePreviewTableProps> = ({ asset, onRemoveClick, onUploadClick }) => {
  const getThumbnailUrl = useCallback((asset: AssetSearchResult) => {
    if (isValidImageFileType(asset)) {
      return asset.s3SignedUrlGet ?? asset.thumbnail ?? '';
    }
    return;
  }, []);

  if (!asset) return null;

  return (
    <Table data-cy="uploaded-image-table" headerRows={1} showDividers spacing="small">
      <TableRow>
        <TableCell></TableCell>
        <TableCell data-cy="uploaded-image-table-filename">Filename</TableCell>
        <TableCell data-cy="uploaded-image-table-actions">Actions</TableCell>
      </TableRow>
      <TableRow data-cy={`uploaded-image-table-row-${asset.assetId}`} key={`${asset.assetId}`}>
        <td data-cy={`asset-table-row-thumbnail-${asset.assetId}`} role="button">
          <Thumbnail noPreviewRequired={!getThumbnailUrl(asset)} thumbnailUrl={getThumbnailUrl(asset)} />
        </td>
        <td data-cy={`asset-table-row-name-${asset.name}`}>
          <span>{asset.name ?? ''}</span>
        </td>
        <td>
          <div className={css.colReferenceId}>
            <ActionButtons onRemoveClick={onRemoveClick} onUploadClick={onUploadClick} />
          </div>
        </td>
      </TableRow>
    </Table>
  );
};
